import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import './style.css';
import '../../../styles/styleGlobal.css';
import { jwtDecode } from 'jwt-decode';
import Dashboard from '../Dashboard/index.js';
import { API_ENDPOINTS, API_BASE_URL } from '../../../js/api.js';


const Inicial = () => {
  const navigate = useNavigate();
  // const [cpf, setCpf] = useState('');
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  // const [codigoempresa, setCodigoempresa] = useState('');
  const [errors, setErrors] = useState({});

  function validarCPF(cpf) {
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

    let soma = 0, resto;
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(10))) return false;

    return true;
  }

  const formatUsuario = (value) => {
    const digits = value.replace(/\D/g, '');

    if (digits.length <= 6) {
      return digits;
    }

    let cpf = digits.slice(0, 11);

    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

    return cpf;
  };

  const handleUsuarioChange = (e) => {
    setUsuario(formatUsuario(e.target.value));
  };

  const entrarEstudante = async (e) => {

    e.preventDefault();

    const newErrors = {};
    const usuarioLimpo = usuario.replace(/\D/g, '');

    if (!usuarioLimpo) {
      newErrors.usuario = 'Informe seu CPF';
    } else if (usuarioLimpo.length !== 11) {
      newErrors.usuario = 'CPF deve ter 11 dígitos';
    } else if (!validarCPF(usuarioLimpo)) {
      newErrors.usuario = 'CPF inválido!';
    }

    if (!senha) {
      newErrors.senha = 'Senha em branco!';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/tce/login-estudante`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          cpf: usuarioLimpo,
          senha,
        }),
      });

      const data = await response.json().catch(() => null);

      if (!response.ok) {
        const msg = data?.errors?.[0] || 'Erro ao fazer login.';
        setErrors({ user: msg });
        return;
      }

      if (data?.token) {
        localStorage.setItem('token', data.token);
        const decoded = jwtDecode(data.token);
        localStorage.setItem('user', JSON.stringify(decoded));
        localStorage.setItem('estudante_id', decoded.id);
        navigate('/tce');
      }
    } catch (err) {
      console.error('Erro no login do Estudante:', err);
      setErrors({ user: 'Erro ao conectar com o servidor.' });
    }
  };

  const entrar = async (e) => {
    e.preventDefault();

    let newErrors = {};

    const usuarioLimpo = usuario.replace(/\D/g, '');

    if (!usuarioLimpo) {
      newErrors.usuario = 'Informe CPF ou Código da Empresa';
    }

    if (!senha) {
      newErrors.senha = 'Senha em branco!';
    }

    if (usuarioLimpo) {
      if (usuarioLimpo.length === 11) {
        if (!validarCPF(usuarioLimpo)) {
          newErrors.usuario = 'CPF inválido!';
        }
      }
      else if (usuarioLimpo.length > 6) {
        newErrors.usuario =
          'Código da empresa inválido';
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const usuarioLimpo = usuario.replace(/\D/g, '');

      const requestBody = {
        usuario: usuarioLimpo,
        senha: senha
      };

      let response = null;
      let data = null;
      try {
        response = await fetch(API_ENDPOINTS.inicial_tokens, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody)
        });
      } catch (err) {
        console.error('Erro de rede ao chamar /tokens:', err);
        setErrors({ user: 'Erro ao conectar com o servidor.' });
        return;
      }

      try {
        data = await response.json().catch(() => null);
      } catch (e) {
        data = null;
      }

      console.log('Login response', response && response.status, data);

      if (!response) {
        setErrors({ user: 'Sem resposta do servidor.' });
        return;
      }

      if (response.status === 401) {
        console.error('Login 401 Unauthorized');
        const userMsg = (data && (data.message || (data.errors && data.errors[0]))) || 'Credenciais inválidas ou acesso não autorizado.';
        setErrors({ user: userMsg });
        return;
      }

      if (response.status === 400) {
        let msg = 'Requisição inválida (400). Verifique os campos.';
        if (data) {
          if (data.message) msg = data.message;
          else if (Array.isArray(data.errors)) {
            msg = data.errors.map(e => (e && (e.message || e.msg)) || e).join('; ');
          } else {
            try { msg = JSON.stringify(data); } catch (e) { /* ignore */ }
          }
        }
        setErrors({ user: msg });
        return;
      }

      if (response.status >= 500) {
        const msg = (data && (data.message || (data.errors && data.errors[0]) || JSON.stringify(data))) || 'Erro interno do servidor (500). Verifique os logs do backend.';
        setErrors({ user: `Erro do servidor: ${msg}` });
        console.error('Servidor 5xx body:', data);
        return;
      }

      if (response.ok && data && data.token) {
        localStorage.setItem('token', data.token);
        const decoded = jwtDecode(data.token);
        const userData = {
          ...decoded,
          acesso_autorizacao: decoded.acesso_autorizacao ?? 0,
          tipo_programa: decoded.tipo === 'usuario_ciee'
            ? null
            : (decoded.tipo_programa ?? null)
        };
        localStorage.setItem('user', JSON.stringify(userData));
        console.log('User logado:', userData);
        localStorage.setItem('empresa_id', decoded.empresa_id);

        if (decoded.tipo === 'usuario_ciee') {
          localStorage.setItem('empresa_id', decoded.empresa_id || '');
          navigate('/dashboard');
          return;
        }

        const tipoPrograma = Number(userData.tipo_programa);

        if (tipoPrograma === 0) {
          navigate('/tce');
          return;
        }

        if (tipoPrograma === 1) {
          navigate('/tca');
          return;
        }

        if (tipoPrograma === 2) {
          navigate('/tca-empregador');
          return;
        }

        setErrors({
          user: 'Tipo de programa inválido.',
        });

      } else {
        setErrors({ user: data && data.errors ? data.errors[0] : 'Erro ao fazer login.' });
      }
    } catch (err) {
      console.error('Erro na requisição:', err);
      setErrors({ user: 'Erro ao conectar com o servidor.' });
    }
  };

  return (
    <div className="container" id="main-container">
      <form className="form-inicial login-form" onSubmit={entrar}>
        <div id="social_media">
          <img src="/logociee.png" alt="Logo" />
        </div>

        <div className="form_header">
          <h1>Login</h1>
        </div>

        <div id="inputs">
          <div className="input-box">
            <label htmlFor="cpf">CPF ou Código da Empresa</label>
            <div className="input-field">
              <i className="fa-solid fa-user"></i>
              <input
                type="text"
                id="usuario"
                name="usuario"
                className="input-tca"
                placeholder="000.000.000-00"
                maxLength="14"
                autoComplete="username"
                value={usuario}
                onChange={handleUsuarioChange}
              />
            </div>
            <span className="error-message">{errors.usuario}</span>
          </div>

          <div className="input-box">
            <label htmlFor="senha">Senha</label>
            <div className="input-field">
              <i className="fa-solid fa-key"></i>
              <input
                type="password"
                id="senha"
                name="senha"
                placeholder="Senha"
                className="input-tca"
                autoComplete="current-password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
              />
            </div>
            <span className="error-message">{errors.senha}</span>
          </div>
        </div>

        <div id="user-error">{errors.user}</div>

        <button className="login" type="submit">Acessar</button>
      </form>
    </div>
  );
};

export default Inicial;
